import { render, staticRenderFns } from "./ApprovalMain.vue?vue&type=template&id=58519ba2"
import script from "./ApprovalMain.vue?vue&type=script&lang=js"
export * from "./ApprovalMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports